// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7c0a067d","488":"57d0c1a1"}[chunkId] + ".chunk.js";
};